import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotifierComponent } from './notifier.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [NotifierComponent],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    NotifierComponent
  ]
})
export class NotifierModule { }
